export interface TeamClientFilterLabelInput {
  id: number | string;
  name?: string | null;
}

/** Formato estándar para opciones de filtro de cliente (teams-child): "1 - Name" */
export function formatTeamClientFilterLabel({ id, name }: TeamClientFilterLabelInput): string {
  const normalizedId = String(id);
  const normalizedName = name?.trim();
  if (normalizedName) {
    return `${normalizedId} - ${normalizedName}`;
  }
  return normalizedId;
}
